// 서비스 이용약관 콘텐츠
export const termsOfServiceContent = {
  title: '서비스 이용약관',
  lastUpdated: '2026년 6월 22일',
  sections: [
    {
      heading: '제1조 (목적)',
      body: '이 약관은 손안의 교회(이하 "서비스")가 제공하는 모바일 커뮤니티 서비스의 이용 조건 및 절차, 이용자와 서비스 간의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.',
    },
    {
      heading: '제2조 (서비스의 내용)',
      body: '서비스는 주님의 교회 멤버를 위한 비공개 커뮤니티로, 다음 기능을 제공합니다.\n\n• 게시물 작성 및 열람 (사진, 텍스트)\n• 댓글 및 좋아요\n• 나눔/재활용 게시판\n• 기도 요청 게시판\n• 푸시 알림\n• 기타 서비스가 추가 개발하여 제공하는 기능',
    },
    {
      heading: '제3조 (이용자 가입)',
      body: '서비스 이용을 위해서는 소셜 계정(Google, Kakao, Naver)을 통한 로그인이 필요합니다.\n\n• 가입 시 이용약관 및 개인정보 처리방침에 동의해야 합니다.\n• 서비스는 교회 멤버 전용이며, 관리자가 가입을 승인합니다.\n• 허위 정보를 기재하거나 타인의 정보를 도용한 경우 이용이 제한될 수 있습니다.',
    },
    {
      heading: '제4조 (이용자의 의무)',
      body: '서비스는 부적절한 콘텐츠와 악의적인 이용자에 대해 무관용(Zero Tolerance) 원칙을 적용합니다.\n\n이용자는 다음 행위를 하여서는 안 됩니다.\n\n• 타인의 개인정보를 무단으로 수집·저장·공개하는 행위\n• 서비스를 이용하여 음란물, 폭력적 콘텐츠, 혐오 표현을 게시하는 행위\n• 타인을 비방·모욕·위협하는 행위\n• 영리 목적의 광고·홍보를 무단으로 게시하는 행위\n• 서비스의 정상적인 운영을 방해하는 행위\n• 관련 법령에 위배되는 행위\n\n위반 시 해당 콘텐츠는 즉시 삭제되며, 이용자의 계정이 정지 또는 삭제될 수 있습니다. 관리자는 신고된 콘텐츠를 24시간 이내에 검토하고 조치합니다.',
    },
    {
      heading: '제5조 (게시물의 관리)',
      body: '이용자가 작성한 게시물의 저작권은 해당 이용자에게 있습니다.\n\n서비스는 다음에 해당하는 게시물을 사전 통지 없이 삭제하거나 비공개 처리할 수 있습니다.\n• 다른 이용자 또는 제3자를 비방하거나 명예를 훼손하는 내용\n• 공공질서 및 미풍양속에 위반되는 내용\n• 범죄 행위에 결부된다고 인정되는 내용\n• 서비스의 저작권 등 지적재산권을 침해하는 내용\n• 기타 관련 법령에 위배되는 내용',
    },
    {
      heading: '제6조 (콘텐츠 신고 및 사용자 차단)',
      body: '서비스는 건전한 커뮤니티 유지를 위해 다음 기능을 제공합니다.\n\n• 신고 기능: 부적절한 게시물 또는 댓글을 신고할 수 있으며, 관리자가 검토 후 적절한 조치를 취합니다.\n• 사용자 차단: 특정 이용자를 차단하면 해당 이용자의 게시물과 댓글이 노출되지 않습니다.\n• 이용 제한: 이용약관을 반복적으로 위반하는 이용자에 대해 서비스 이용을 제한할 수 있습니다.',
    },
    {
      heading: '제7조 (서비스의 변경 및 중단)',
      body: '서비스는 운영상·기술상의 필요에 따라 서비스의 전부 또는 일부를 변경하거나 중단할 수 있습니다.\n\n• 서비스 변경 또는 중단 시 앱 내 공지사항을 통해 사전에 고지합니다.\n• 불가피한 사유(천재지변, 시스템 장애 등)로 사전 고지가 불가한 경우 사후에 고지할 수 있습니다.',
    },
    {
      heading: '제8조 (회원 탈퇴 및 자격 상실)',
      body: '이용자는 언제든지 앱 내 마이페이지에서 회원 탈퇴를 요청할 수 있으며, 서비스는 즉시 처리합니다.\n\n• 탈퇴 시 작성한 게시글, 댓글 등 모든 콘텐츠가 삭제됩니다.\n• 탈퇴된 계정으로는 다시 로그인할 수 없습니다.\n• 탈퇴 후 30일 이내에 관리자에게 요청하면 계정을 복구할 수 있습니다. 30일 이후에는 모든 데이터가 완전히 삭제되어 복구할 수 없습니다.\n\n다음의 경우 서비스는 회원 자격을 제한 또는 상실시킬 수 있습니다.\n• 가입 시 허위 내용을 등록한 경우\n• 다른 이용자의 서비스 이용을 방해하거나 정보를 도용한 경우\n• 서비스를 이용하여 법령 또는 이 약관이 금지하는 행위를 한 경우',
    },
    {
      heading: '제9조 (면책 조항)',
      body: '서비스는 다음의 사항에 대해 책임을 지지 않습니다.\n\n• 천재지변 또는 이에 준하는 불가항력으로 인해 서비스를 제공할 수 없는 경우\n• 이용자의 귀책사유로 인한 서비스 이용 장애\n• 이용자가 게시한 정보·자료·사실의 신뢰도, 정확성 등에 관한 사항\n• 이용자 간 또는 이용자와 제3자 간에 서비스를 매개로 발생한 분쟁',
    },
    {
      heading: '제10조 (분쟁 해결)',
      body: '서비스 이용과 관련하여 분쟁이 발생한 경우, 서비스와 이용자는 분쟁 해결을 위해 성실히 협의합니다.\n\n협의가 이루어지지 않을 경우, 관할 법원은 민사소송법상의 관할 법원으로 합니다.',
    },
    {
      heading: '부칙',
      body: '이 약관은 2026년 6월 22일부터 시행됩니다.',
    },
  ],
};
